import { render, staticRenderFns } from "./TaskKanbanBoard.vue?vue&type=template&id=3d5a464d&scoped=true"
import script from "./TaskKanbanBoard.vue?vue&type=script&lang=ts"
export * from "./TaskKanbanBoard.vue?vue&type=script&lang=ts"
import style0 from "./TaskKanbanBoard.vue?vue&type=style&index=0&id=3d5a464d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a464d",
  null
  
)

export default component.exports